<template>
    <div class="page">
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/cp02.jpg" alt="">
        </div>
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/cp03.jpg" alt="">
        </div>
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/cp04.jpg" alt="">
        </div>
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/cp05.jpg" alt="">
        </div>
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/cp06.jpg" alt="">
        </div>
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/cp07.jpg" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "service"
    }
</script>

<style scoped  lang="scss">
    .base {
        color: #333333;
        position: relative;
        overflow: hidden;
        background: white;
    }
</style>